import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import reportWebVitals from './reportWebVitals'
import App from './App'
import { ThemeProvider } from './context/ThemeContext'
import { AppWrapper } from './components/common/PageMeta'
import { AuthProvider } from './context/AuthContext'
import { Toaster } from 'react-hot-toast'
import { CreateRegisterProvider } from './context/CreateRegisterContext'
import { ActivityProvider } from './context/ActivityContext'
import { BusinessProvider } from './context/BusinessContext'
import { CommonProvider } from './context/CommonContext'
import { ProfessionalProvider } from './context/ProfessionalContext'
import { CompanyProvider } from './context/CompanyContext'
import { TargetProvider } from './context/TargetContext'
import { ProductProvider } from './context/ProductContext'
import { ContactProvider } from './context/ContactContext'
import { CalendarProvider } from './context/CalendarContext'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
    <React.StrictMode>
        <AppWrapper>
            <ThemeProvider>
                <AuthProvider>
                    <TargetProvider>
                        <ContactProvider>
                            <CalendarProvider>
                                <ProfessionalProvider>
                                    <ProductProvider>
                                        <CompanyProvider>
                                            <ActivityProvider>
                                                <CommonProvider>
                                                    <CreateRegisterProvider>
                                                        <BusinessProvider>
                                                            <Toaster position='bottom-center' reverseOrder={false} />
                                                            <App />
                                                        </BusinessProvider>
                                                    </CreateRegisterProvider>
                                                </CommonProvider>
                                            </ActivityProvider>
                                        </CompanyProvider>
                                    </ProductProvider>
                                </ProfessionalProvider>
                            </CalendarProvider>
                        </ContactProvider>
                    </TargetProvider>
                </AuthProvider>
            </ThemeProvider>
        </AppWrapper>
    </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
